import { Icons } from "@ppb/the-wall-icons/GenericIcon/GenericIcon";
import type { ReactNode } from "react";

export enum SelectionsBoardTheme {
  Blue = "blue",
  Yellow = "yellow",
}

export type SelectionsBoardOnSelectionRemove = () => void;

export type SelectionsBoardProps = {
  title?: string;
  hasHeader?: boolean;
  theme: SelectionsBoardTheme;
  icon?: Icons;
  onRemoveSelection?: SelectionsBoardOnSelectionRemove;
  children: ReactNode;
};

export type SelectionsBoardViewModel = SelectionsBoardProps;

export type SelectionsBoardSectionProps = {
  title: string;
  odd?: string;
  theme?: SelectionsBoardTheme;
  hasHeader?: boolean;
  children: ReactNode;
};

export type SelectionsBoardSectionViewModel = SelectionsBoardSectionProps;
